<template>
    <v-card flat>
        <v-overlay :value="loadingUnmatchedShopData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title
                >{{
                    activeUnmatchedShop.customer_code || activeUnmatchedShop.customer_name
                        ? `${activeUnmatchedShop.customer_name ? activeUnmatchedShop.customer_name : ""} (${
                              activeUnmatchedShop.customer_code
                          })`
                        : activeUnmatchedShop.id
                }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
                color="bal-red"
                dark
                @click="saveInvoice"
                v-if="hasPermissionForAction(PermissionsConstants.UNMATCHED_SHOP, PermissionsConstants.EDIT)"
            >
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>

            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "Shop info" | t }}
            </v-tab>
            <v-tab-item>
                <div class="pa-5">
                    <v-row v-if="activeUnmatchedShop && activeUnmatchedShop.invoice_number">
                        <v-col class="col-item row-title" cols="3">{{ "Invoice number" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.invoice_number ? activeUnmatchedShop.invoice_number : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Store name" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.main_customer_name ? activeUnmatchedShop.main_customer_name : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Store code" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.main_customer_code ? activeUnmatchedShop.main_customer_code : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Shop name" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.customer_name ? activeUnmatchedShop.customer_name : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Shop code" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.customer_code ? activeUnmatchedShop.customer_code : "-" }}
                        </v-col>
                    </v-row>
                    <v-row v-if="activeUnmatchedShop.customer_address">
                        <v-col class="col-item row-title" cols="3">{{ "Shop address" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.customer_address }}
                        </v-col>
                    </v-row>
                    <v-row v-if="activeUnmatchedShop.customer_city">
                        <v-col class="col-item row-title" cols="3">{{ "Shop city" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.customer_city }}
                        </v-col>
                    </v-row>
                    <v-row v-if="activeUnmatchedShop.customer_postal_code">
                        <v-col class="col-item row-title" cols="3">{{ "Shop postal code" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.customer_postal_code }}
                        </v-col>
                    </v-row>
                    <v-row v-if="activeUnmatchedShop.customer_county">
                        <v-col class="col-item row-title" cols="3">{{ "Shop county" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ activeUnmatchedShop.customer_county }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="3">{{ "Type" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{
                                activeUnmatchedShop.type
                                    ? activeUnmatchedShop.type.charAt(0).toUpperCase() +
                                      activeUnmatchedShop.type.slice(1).replaceAll("_", " ")
                                    : "-"
                            }}
                        </v-col>
                    </v-row>
                    <v-row class="pb-0 mb-0" v-if="!shop">
                        <v-col class="col-item row-title pb-0 mb-0" cols="3">{{ "Choose shop" | t }}</v-col>
                        <v-col class="col-item row-title pb-0 mb-0" cols="6">
                            <v-autocomplete
                                :disabled="
                                    !hasPermissionForAction(
                                        PermissionsConstants.UNMATCHED_SHOP,
                                        PermissionsConstants.EDIT
                                    )
                                "
                                v-model="shopsComplete"
                                :items="shops"
                                :loading="isLoading"
                                :placeholder="'Start typing to Search' | t"
                                class="col-item mt-0 pt-0 pb-0 mb-0"
                                color="bal-red"
                                dense
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="id"
                                outlined
                                return-object
                            />
                        </v-col>
                    </v-row>
                    <v-divider class="my-5 mb-2" />
                    <v-row v-if="!shop">
                        <v-spacer />
                        <v-btn
                            v-if="
                                hasPermissionForAction(PermissionsConstants.UNMATCHED_SHOP, PermissionsConstants.EDIT)
                            "
                            dark
                            color="bal-red"
                            class="px-2 mr-2 mt-3"
                            @click.stop="addNewShop"
                            style="min-width: 0;"
                        >
                            <v-icon>add</v-icon><span>{{ "Add shop" | t }}</span>
                        </v-btn>
                    </v-row>
                    <shop-view v-else />
                </div>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Store from "../../store";
import ShopView from "./views/shop-view";
import { PermissionsConstants } from "@/permissions";
export default {
    components: { ShopView },
    name: "unmatched-shops-view",
    data() {
        return {
            shopsComplete: null,
            isLoading: false,
            tab: 0
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        await Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsData", {
            invoiceId: this.$route.params.invoiceId,
            invoiceType: this.$route.params.invoiceType
        });
    },
    computed: {
        ...mapState("UnmatchedShopsStore", [
            "shops",
            "unmatchedShops",
            "unmatchedShopDialog",
            "activeUnmatchedShop",
            "loadingUnmatchedShopData",
            "shop"
        ]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        handleKeyboardListener(e) {
            if (e.keyCode === 27 || e.key === "Escape") this.closeDrawer();
            if (document.activeElement.tagName !== "INPUT" && (e.keyCode === 13 || e.key === "Enter")) {
                this.saveInvoice();
            }
        },
        closeDrawer() {
            this.$router.push({ name: "unmatched-shops-list" });
        },
        async saveInvoice() {
            await Store.commit("UnmatchedShopsStore/updateUnmatchedShopProperty", {
                prop: "shop_code_id",
                value: this.shopsComplete ? this.shopsComplete.id : null
            });
            let currentUserIndex = this.unmatchedShops.findIndex(p => p.id === this.activeUnmatchedShop.id);
            await Store.dispatch("UnmatchedShopsStore/submitUnmatchedShopsData", this.activeUnmatchedShop);
            if (currentUserIndex + 1 !== this.unmatchedShops.length) {
                this.shopsComplete = null;
                await Store.commit("UnmatchedShopsStore/resetNewShopData");
                const newInvoice = this.unmatchedShops[currentUserIndex + 1];
                await Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsData", {
                    invoiceId: newInvoice.id,
                    invoiceType: newInvoice.type
                });
                await this.$router.push({
                    name: this.$route.name,
                    params: { invoiceId: newInvoice.id, invoiceType: newInvoice.type }
                });
            }
            //await this.$router.push({ name: "unmatched-shops-list" });
        },
        addNewShop() {
            Store.commit("UnmatchedShopsStore/addNewShopData");
        },
        updateShopField(value, field) {
            Store.commit("UnmatchedShopsStore/updateNewShopProperty", {
                prop: field,
                value: value
            });
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}
</style>
